module.exports = __webpack_public_path__ + "static/media/hotel-quality-bed.4aed6cba.jpg";